import { zoraNftCreatorV1ABI as abi } from '@zoralabs/nft-drop-contracts'
import { addresses } from '../../addresses'

export const ZoraNFTCreatorV1 = {
  abi,
  address: addresses.ZORA_721.FACTORY_PROXY,
} as const
